import TYPES from './actionTypes';

export const save = (params) => ({
  type: TYPES.SAVE,
  payload: {
    params,
  },
});

export const saving = (params) => ({
  type: TYPES.SAVING,
});

export const saved = (resp) => ({
  type: TYPES.SAVED,
  payload: {
    resp,
  },
});

export const failedToSave = (resp) => ({
  type: TYPES.FAILED_TO_SAVE,
  payload: {
    resp,
  },
});

export const confirmCreation = (userId) => ({
  type: TYPES.CONFIRM_CREATION,
  payload: {
    userId,
  },
});
export const afterConfirmCreation = () => ({
  type: TYPES.AFTER_CONFIRM_CREATION,
  payload: {},
});
